import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap, switchMap, map, catchError } from 'rxjs/operators';
import * as fromShared from '../../../shared';

import * as IndirectRateRuleActions from './indirect-rate-rule.actions';
import { IndirectRateService } from '../../indirect-rate.service';

@Injectable()
export class IndirectRateRuleEffects {
    getIndirectRateRulesIndirectRateRules$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(IndirectRateRuleActions.getIndirectRateRules),
            switchMap(action =>
                this.service.getIndirectRateRules(action.rateType, action.costCenter).pipe(
                    map(indirectRateRules =>
                        IndirectRateRuleActions.loadIndirectRateRules({
                            indirectRateRules
                        })
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    constructor(
        private actions$: Actions,
        private service: IndirectRateService
    ) {}
}
